/* eslint-disable react/prop-types */
import i18n from "../../../plugins/locale/i18n";
import loadDictionary from "../../../plugins/locale/load-dictionary";
import { Button, Form, ListGroup, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import BankAccountService from "../../../service/bank-account-service";

const bankAccountService = new BankAccountService();

await loadDictionary('bank-account-charge-bon-card-window');

function ChargeBonCardWindow({isOpenWindow, onCloseWindow, bonCards}) {
    const [tourismBankAccounts, setTourismBankAccounts] = useState([]);
    const [originBankAccountId, setOriginBankAccountId] = useState();
    const [totalChargeBonCardAmounts, setTotalChargeBonCardAmounts] = useState(0);
    const [chargeBonCardAmounts, setChargeBonCardAmounts] = useState([]);
 
    const handleClose = (refresh = false) => {
        onCloseWindow(refresh);
    };
 
    const handleSubmit = () => {
        bankAccountService.chargeBonCards(originBankAccountId, chargeBonCardAmounts.map(item => { return {id: item.bonCard.id, amount: item.amount}}))
            .then((response) => {
                if(response.result === "done") {
                    //
                }
            })
            .catch((reason) => {
                console.log(reason);
            })
            .finally(() => {
                handleClose(true);
            });
    }

    const changeBonCardAmount = (amount, account) => {
        setChargeBonCardAmounts(prev => prev.filter(item => item.bonCard.id !== account.id));
        
        if(amount > 0) {
            setChargeBonCardAmounts(prev => [...prev, {bonCard: account, amount: Number(amount)}]);
        }
    };

    useEffect(() => {
        if(!isOpenWindow || !bonCards || Array(bonCards).length === 0) {
            return;
        }

        bankAccountService.findAllByCompany().then(bankAccountOptions => {
            setTourismBankAccounts(bankAccountOptions.filter(bankAccount => bankAccount.bank_id == 2 && bankAccount.type == "bank_account"));
        });
    }, [isOpenWindow, bonCards]);

    useEffect(() => {
        setOriginBankAccountId(tourismBankAccounts[0]?.id);
    }, [tourismBankAccounts]);

    useEffect(() => {
        setTotalChargeBonCardAmounts(chargeBonCardAmounts.reduce((previousValue, current) => previousValue + Number(current.amount), 0));
    }, [chargeBonCardAmounts]);

    return (
        <Modal show={isOpenWindow} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>{i18n.t("bank-account-charge-bon-card-window.title")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form method="POST" id="ChargeBonCardForm" onSubmit={e => {e.preventDefault(); handleSubmit();}}>
                    <Form.Group className="mb-3">
                        <Form.Label>{i18n.t("bank-account-charge-bon-card-window.origin_bank_account")}</Form.Label>
                        <Form.Select autoFocus value={originBankAccountId} onChange={e => {setOriginBankAccountId(e.target.value)}}>
                            {tourismBankAccounts.map((bankAccount) => <option key={bankAccount.id} value={bankAccount.id}>{bankAccount.name} {bankAccount.account_number}</option>)}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{i18n.t("bank-account-charge-bon-card-window.selected_bon_card_list")}</Form.Label>
                        <ListGroup as="ul" dir="ltr" className="pe-0">
                            {bonCards && bonCards.map((bonCard) => (
                                <ListGroup.Item as="li" key={bonCard.id} className="d-flex justify-content-between align-items-top">
                                    <div className="ms-auto">
                                        <div className="">{bonCard.card_number}</div>
                                        <span className="text-secondary">{Number(bonCard.balance).toLocaleString()}</span>
                                    </div>
                                    <div className="me-3">
                                        <Form.Control type="number" size="sm" min={0} onChange={(e) => {changeBonCardAmount(e.target.value, bonCard)}} />
                                    </div>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    </Form.Group>
                </Form>
                <p className="text-info-emphasis fw-bold">{i18n.t("bank-account-charge-bon-card-window.total_amount_notice", {amount: totalChargeBonCardAmounts.toLocaleString()})}</p>
                
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>{i18n.t("bank-account-charge-bon-card-window.cancel_button")}</Button>
                <Button variant="primary" type="submit" form="ChargeBonCardForm" >{i18n.t("bank-account-charge-bon-card-window.charge_button")}</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ChargeBonCardWindow;